import React from 'react';
import { Col, Row, Table } from 'reactstrap';

import { Input, Resource, Select } from '@/components/form';
import ResourceList from '@/components/resources/list';
import View from '@/components/view';
import object from '@/services/utils/object';

export default () => (
  <View>
    <ResourceList
      resource="Zone"
      deleteMultiple
      filters={() => (
        <Row>
          <Col lg={3}>
            <Input name="name" />
          </Col>
          <Col lg={3}>
            <Resource name="['parent.id']" resource="Zone" display="name" clearable multiple useId />
          </Col>
          <Col lg={3}>
            <Resource name="['type.id']" resource="ZoneType" display="name" clearable multiple useId />
          </Col>
          <Col lg={3}>
            <Select name="geometryType" clearable multiple />
          </Col>
        </Row>
      )}
      body={({ collection, renderColumn, renderItemActions, renderSelect }) => (
        <Table responsive hover>
          <thead className="thead-light">
            <tr>
              {renderColumn(renderSelect('*'), false)}
              {renderColumn('id')}
              {renderColumn('name')}
              {renderColumn('parent.name')}
              {renderColumn('type.name')}
              {renderColumn('description', false)}
              {renderColumn()}
            </tr>
          </thead>
          <tbody>
            {collection.map((item) => (
              <tr key={item.id}>
                <td>{renderSelect(item.id)}</td>
                <td>{item.id}</td>
                <td>{item.name}</td>
                <td>
                  {item.parent && typeof item.parent === 'object' && item.parent.name}
                  {item.parent && typeof item.parent === 'string' && item.name}
                </td>
                <td>{object.get('type.name', item)}</td>
                <td>{item.description}</td>
                <td>{renderItemActions(item)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    />
  </View>
);
